// extracted by css-extract-rspack-plugin
export default {"overview":"_RyCjDw_D9E2Et7c","title":"TChZ4GCafm02bPYv","main":"md52O0el_L8tGaL6","field":"QdkiDDMoMTO0AfqG","notes":"lqx9heBCFEUVzSkG","footer":"wEErWeqwo4IudgTJ"};